'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.injectAppBarSetter = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _actions = require('./actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var injectAppBarSetter = exports.injectAppBarSetter = function injectAppBarSetter(Component) {
  var _class, _temp;

  return _temp = _class = function (_React$Component) {
    _inherits(Setter, _React$Component);

    function Setter(props, context) {
      _classCallCheck(this, Setter);

      var _this = _possibleConstructorReturn(this, (Setter.__proto__ || Object.getPrototypeOf(Setter)).call(this, props, context));

      if (props.appBar) {
        _this.context.store.dispatch((0, _actions.setAppBar)(props.appBar));
      }
      return _this;
    }

    _createClass(Setter, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            appBar = _props.appBar,
            others = _objectWithoutProperties(_props, ['appBar']);

        return _react2.default.createElement(Component, others);
      }
    }]);

    return Setter;
  }(_react2.default.Component), _class.propTypes = {
    appBar: _react2.default.PropTypes.object
  }, _class.contextTypes = {
    store: _react2.default.PropTypes.object.isRequired
  }, _temp;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Container components/DrawerMenuContainer/AppBarSetter.js
 ** module id = 277
 ** module chunks = 0
 **/